import { supabase } from '@/integrations/supabase/client';

export interface PixabayImage {
  id: number;
  webformatURL: string;
  largeImageURL: string;
  tags: string;
  user: string;
  views: number;
  downloads: number;
  likes: number;
  previewURL: string;
}

export interface PixabayResponse {
  total: number;
  totalHits: number;
  hits: PixabayImage[];
}

export const pixabayService = async (query: string, perPage: number = 50): Promise<PixabayResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('runAgent', {
      body: { agent: 'pixabay', query, perPage }
    });

    if (error) {
      throw new Error(error.message);
    }

    return data;
  } catch (error: any) {
    console.error('Pixabay service error:', error);
    throw new Error(`Failed to search images: ${error.message}`);
  }
};

export const formatPixabayResponse = (
  data: PixabayResponse,
  query: string,
  _isDarkMode: boolean = false
): string => {
  const images = (data?.hits || []).slice(0, 50).map((img) => ({
    url: img.largeImageURL || img.webformatURL || img.previewURL,
  })).filter(x => x.url);

  const payload = {
    __pixabay: true,
    images,
    query
  };
  return JSON.stringify(payload);
};
